import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import CreateDestinationModal from "./CreateDestinationModal.layout";

const mapStateToProps = (state) => ({
    trackers: state.allTrackersState.trackers,
    singleTracker: state.allTrackersState.singleTracker,
    singleTrackerStatus: state.allTrackersState.singleTrackerStatus,
    language: state.languagesState.languages,
    destinationsTypes: state.allDestinationsTypeState.destinations,
    sourcesTypes: state.allSourcesTypesState.sources,
    bussiness: state.allDashboardDatasState.getAllDashboardDatas.bussiness,
    appObject: state.setAppId.value,
});
const mapDispatchToProps = () => ({});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(CreateDestinationModal);
